export default __webpack_public_path__ + "static/media/mi3.7ff8f881.jpg";